import type { TranslationNamespace } from '@autoplan/common'
import { type ReactNode, useMemo } from 'react'
import { LocaleProvider, useLocale } from '@autoplan/web-sanity'
import { UiLabelsProvider } from '@autoplan/web-ui'
import { buildUiLabels } from '@_shared/helpers/helper.ui-labels'

type I18nProviderProps = {
  language?: string | null
  namespace: TranslationNamespace
  children: ReactNode
}

export function I18nProvider({ language, namespace, children }: I18nProviderProps) {
  return (
    <LocaleProvider language={language} namespace={namespace}>
      <UiLabels>{children}</UiLabels>
    </LocaleProvider>
  )
}

function UiLabels({ children }: { children: ReactNode }) {
  const { t } = useLocale()
  const labels = useMemo(() => buildUiLabels(t), [t])

  return <UiLabelsProvider labels={labels}>{children}</UiLabelsProvider>
}
